export function withValidity(path: string) {
  const url = new URL(path, window.location.origin);
  url.searchParams.set('validity', new URLSearchParams(window.location.search).get('validity') || 'ACTIVE');
  return `${url.pathname}${url.search}`;
}
